import { Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Element } from './element';

export abstract class InputElement extends Element {
    @Input() entity: any;
    @Input() control: FormControl;
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/components/elements/input-element.ts